import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { Col, Row, Form, Input, Button, Spin, message } from 'antd';
import { userMangement } from '../../redux/actions/authActions';
import LoginImage from '../../assets/common/login.png';
import { MARKETING_ONBOARD_SUCCESS } from '../../constants/messages';
import { replaceMultiple } from '../../utilities/helpers';
import { LOGIN } from '../../constants/routes';

function MarketOnBoardScreen() {
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();
  const history = useHistory();
  const { id } = useParams();
  const query = new URLSearchParams(search);
  const dispatch = useDispatch();

  const onFinish = (values) => {
    setLoading(true);
    dispatch(
      userMangement('onboard.marketing_company', {
        id: parseInt(id),
        token: query.get('token'),
        name: get(values, 'name'),
        new_password: get(values, 'password'),
      })
    )
      .then(() => {
        setLoading(false);
        message.success(MARKETING_ONBOARD_SUCCESS);
        history.replace(LOGIN);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinishFailed = () => {};

  const verifyToken = () => {
    setLoading(true);
    dispatch(
      userMangement('verify.link.onboard.marketing_company', {
        id: parseInt(id),
        token: query.get('token'),
      })
    )
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        history.replace(LOGIN);
      });
  };

  useEffect(() => {
    verifyToken();
  }, []);

  return (
    <Spin spinning={loading}>
      <Row>
        <Col span={16} style={{ textAlign: 'center' }}>
          <img src={LoginImage} alt="" />
        </Col>
        <Col span={8}>
          <div className="login-container">
            <div className="heading">
              Hi {query.get('marketing_company_name')}
            </div>
            <div className="login-form">
              <Form
                name="basic"
                layout="vertical"
                initialValues={{
                  email: replaceMultiple(query.get('email'), {
                    ' ': '+',
                  }),
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                requiredMark={false}
              >
                <div className="mt-20">
                  <Form.Item
                    label="Name"
                    name="name"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your Name!',
                      },
                    ]}
                  >
                    <Input disbaled placeholder="Enter you name!" />
                  </Form.Item>
                </div>
                <div className="mt-20">
                  <Form.Item
                    label="Email id "
                    name="email"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your registered email!',
                      },
                      {
                        type: 'email',
                        message: 'Please Input valid email',
                      },
                    ]}
                  >
                    <Input disabled placeholder="Enter Email or mobile no." />
                  </Form.Item>
                </div>

                <div className="mt-40">
                  <Form.Item
                    label="Create Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                  >
                    <Input.Password placeholder="Enter your password" />
                  </Form.Item>
                </div>
                <div className="mt-40">
                  <Form.Item
                    label="Re-enter Password"
                    name="confirm_password"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              'The two passwords that you entered do not match'
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password placeholder="Re-Enter your password" />
                  </Form.Item>
                </div>

                <div className="mt-20">
                  <Form.Item>
                    <Button type="primary" block htmlType="submit">
                      Sign Up
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Spin>
  );
}

export default MarketOnBoardScreen;
